import { createFileRoute } from '@tanstack/react-router'
import '../App.css'
import Banner from '../components/Banner'
import Breadcrumb from '../components/Breadcrumb'
import StopoversToursContainer from '../components/StopoversToursContainer'
import HotelsContainer from '../components/HotelsContainer'
import TopTipsContainer from '../components/TopTipsContainer'
import LocalToursContainer from '../components/LocalToursContainer'
import USP from '../components/USP'

export const Route = createFileRoute('/stopovers')({
  component: StopoversPage,
})

function StopoversPage() {
  return (
    <div className="d-flex flex-column container-fluid p-0">
      <Breadcrumb items={[{ label: 'Stopovers' }]} />
      <Banner title="Stopovers" image="https://cdn.trailfinders.com/stopovers-banner.png">
        <div className="d-flex justify-content-center text-center align-content-end mt-4">
          <div
            className="trustpilot-widget"
            data-locale="en-GB"
            data-template-id="5419b732fbfb950b10de65e5"
            data-businessunit-id="4a52202d0000640005045750"
            data-style-height="100px"
            data-style-width="100%"
            data-theme="dark"
            data-token="9665cb67-074d-4b1f-8d46-4ab7f4f76081"
            data-font-family="Libre Franklin"
            data-text-color="#fefefe"
          >
            <a href="https://www.trustpilot.com/review/www.trailfinders.com" target="_blank" rel="noopener" className="text-white">Trustpilot</a>
          </div>
        </div>
        <script type="text/javascript" src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js" async></script>
      </Banner>
      <USP />
      <div className="bg-light pt-5 pt-md-4">
        <StopoversToursContainer keyWord={'Aus & NZ stopovers'} title={'Popular stopovers on the way to Australia & New Zealand'} />
        <StopoversToursContainer keyWord={'Other Stopovers'} title={'Other stopovers'} />
        <HotelsContainer title={'Our worldwide stopovers hotels'} />
        <LocalToursContainer title={'What to do on your stopover'} />
      </div>
      <TopTipsContainer title={'Stopovers Top Tips from our Travel Experts'} />
    </div>
  )
}
